function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { computed, defineComponent, h } from '@vue/composition-api';
import EmptyBoxOutlined from '@kibt/meta-ui-icons/es/icons/EmptyBoxOutlined';
import WifiOffOutlined from '@kibt/meta-ui-icons/es/icons/WifiOffOutlined';
import { withInstall } from '../util/index';
import { createNamespace } from '../util/create';
import Loading from '../loading';
import "../style/components/error-wrap.css";

var _createNamespace = createNamespace('error-wrap'),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

export var ErrWrapperStatus;

(function (ErrWrapperStatus) {
  ErrWrapperStatus["Success"] = "success";
  ErrWrapperStatus["Loading"] = "loading";
  ErrWrapperStatus["Empty"] = "empty";
  ErrWrapperStatus["NetWorkErr"] = "networkerr";
})(ErrWrapperStatus || (ErrWrapperStatus = {}));

var ErrorWrap = defineComponent({
  name: name,
  props: {
    status: {
      type: String,
      "default": ErrWrapperStatus.Success
    },
    networkText: {
      type: String,
      "default": ''
    },
    emptyText: {
      type: String,
      "default": ''
    }
  },
  slots: ['empty', 'default', 'loading', 'network'],
  setup: function setup(props, _ref) {
    var slots = _ref.slots,
        emit = _ref.emit;
    // const {status} = props;
    var status = computed(function () {
      return props.status;
    });

    var renderLoading = function renderLoading() {
      if (status.value === ErrWrapperStatus.Loading) {
        return h("div", {
          "class": bem('loading')
        }, [slots.loading ? slots.loading() : h(Loading, {
          "class": bem('loading-icon')
        })]);
      }
    };

    var renderNoData = function renderNoData() {
      if (status.value === ErrWrapperStatus.Empty) {
        return h("div", {
          "class": bem('empty')
        }, [slots.empty ? slots.empty() : h(EmptyBoxOutlined, {
          "class": bem('empty-content')
        }), props.emptyText && h("p", [props.emptyText])]);
      }
    };

    var renderNetWork = function renderNetWork() {
      if (status.value === ErrWrapperStatus.NetWorkErr) {
        return h("div", {
          "class": bem('network')
        }, [slots.network ? slots.network() : h(WifiOffOutlined, {
          "class": bem('network-content')
        }), props.networkText && h("p", [props.networkText])]);
      }
    };

    return function () {
      var _slots$default;

      var Content = status.value === ErrWrapperStatus.Success ? (_slots$default = slots["default"]) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots) : '';
      return h("div", {
        "class": bem()
      }, [Content, renderNoData(), renderLoading(), renderNetWork()]);
    };
  }
});
withInstall(ErrorWrap);
export default ErrorWrap;